export const AFTER_SALES_VALID_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
]
export const AFTER_SALES_DAMAGED_PRODUCT_AMOUNT_THRESHOLD = 30
